// Set filter
export const setFilter = (name, value) => {
	return {
		type: 'SET_FILTER',
		options: {
			name,
			value,
		}
	}
}

// Clear all filters
export const clearFilters = () => {
	return {
		type: 'CLEAR_FILTERS',
	}
}



// WEBPACK FOOTER //
// ./src/actions/filters.js